export const SELECTED_PROPERTY_POSITIONS = {
    TOP: 'top',
    BOTTOM: 'bottom',
    NONE: 'none',
};

export const SHOW_MORE_CLICK_EVENT = 'show-more-click';
